





















import _ from 'lodash'
import { BaseForm } from '@/services/BaseForm'
import { Component, Provide } from 'vue-property-decorator'
import { IFormOption, INPUT_TYPES } from '@/components/form/FieldTypes'
import RuleHelper from '@/utils/RuleHelper'
import { IPatient } from '@/store/modules/views/patient/states'
import { Action, Getter } from 'vuex-class'
import { getSubDistrict } from '@/services/SubDistrict'
import { getDistrict } from '@/services/District'
import { getProvince } from '@/services/Province'
import moment from 'moment'
import { IJob } from '@/store/modules/views/job/states'

@Component
export default class PatientAssessment extends BaseForm<any> {
  @Provide('formName') public formName = 'patientAssessmentForm'

  private header = `แบบประเมินคัดกรองผู้สูงอายุ/ผู้ป่วย`
  private loading = false
  private data: { [key: string]: any }
  private isReadOnly = true
  private province = getProvince().province
  private districtValue = ''
  private provinceValue = ''

  @Getter('patient/patientDetail')
  private patientDetail!: IPatient

  @Action('patient/getPatientById')
  private getPatientById!: (options: {}) => void

  @Action('patient/putPatientAssessment')
  private putPatientAssessment!: (options: {}) => void

  @Action('job/getJobList')
  private getJobList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
      includes: string,
    },
  }) => void

  @Getter('job/itemLists')
  private jobList!: IJob[]

  public async created() {
    this.loading = true
    if (this.$route.params.status) {
      await this.getPatientById({ id: this.$route.params.status })

      if (this.patientDetail) {
        const filter = {
          _id: [{
            condition: 'is',
            value: this.patientDetail._id,
          }],
        }
        await this.getJobList({
          headers: {
            page: 1,
            limit: 1,
            sortBy: '_id',
            sortDesc: false,
            search: Buffer.from('').toString('base64'),
            filter: Buffer.from(JSON.stringify(filter)).toString('base64'),
            includes: '-',
          },
        })
        this.isReadOnly = this.patientDetail ? !_.isEmpty(this.jobList) : false
      }
    }
    this.loading = false
  }

  get dataStore() {
    return this.getByName(this.formName)
  }

  get district() {
    return getDistrict().district
  }

  get subDistrict() {
    return getSubDistrict().subDistrict
  }

  get formDefault(): any {
    return this.patientDetail ? this.doConvertIntToString(this.patientDetail.metadata) : {}
  }

  // ข. ข้อมูลสิทธิด้านสุขภาพเฉพาะตัว
  get patientHealthy(): IFormOption[] {
    return [
      {
        type: INPUT_TYPES.TITLE,
        col: '12',
        props: {
          title: 'ข้อมูลสิทธิด้านสุขภาพเฉพาะตัว',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'patientHealthyMedicalTreatment',
          title: 'สิทธิการรักษา',
          defaultValue: this.formDefault && this.formDefault.patientHealthyMedicalTreatment
            ? this.formDefault.patientHealthyMedicalTreatment
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'บัตรทอง', value: 'บัตรทอง' },
            { text: 'ประกันสังคม', value: 'ประกันสังคม' },
            { text: 'ข้าราชการ/รัฐวิสาหกิจ', value: 'ข้าราชการ/รัฐวิสาหกิจ' },
            { text: 'อื่นๆ', value: 'อื่นๆ' },
          ],
        },
      },
      {
        type: INPUT_TYPES.TEXT,
        col: '5',
        isHide: true,
        props: {
          name: 'patientHealthyMedicalTreatmentOther',
          title: 'อื่นๆ',
          placeholder: 'กรุณากรอกสิทธิการรักษา',
          dense: true,
          defaultValue: this.formDefault && this.formDefault.patientHealthyMedicalTreatmentOther
            ? this.formDefault.patientHealthyMedicalTreatmentOther
            : undefined,
          readonly: this.isReadOnly,
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'patientHealthyCaretakerRelation',
          title: 'ความสัมพันธ์',
          defaultValue: this.formDefault && this.formDefault.patientHealthyCaretakerRelation
            ? this.formDefault.patientHealthyCaretakerRelation
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'บิดา', value: 'บิดา' },
            { text: 'มารดา', value: 'มารดา' },
            { text: 'บุตร', value: 'บุตร' },
            { text: 'สามี/ภรรยา', value: 'สามี/ภรรยา' },
            { text: 'อื่นๆ', value: 'อื่นๆ' },
          ],
        },
      },
      {
        type: INPUT_TYPES.TEXT,
        col: '5',
        isHide: true,
        props: {
          name: 'patientHealthyCaretakerRelationOther',
          title: 'อื่นๆ',
          placeholder: 'กรุณากรอกความสัมพันธ์',
          dense: true,
          defaultValue: this.formDefault && this.formDefault.patientHealthyCaretakerRelationOther
            ? this.formDefault.patientHealthyCaretakerRelationOther
            : undefined,
          readonly: this.isReadOnly,
        },
      },
    ]
  }

  // ค. การตรวจร่างกาย
  get physicalExamination(): IFormOption[] {
    return [
      {
        type: INPUT_TYPES.TITLE,
        col: '12',
        props: {
          title: 'การตรวจร่างกาย',
        },
      },
      {
        type: INPUT_TYPES.TEXT,
        col: '4',
        props: {
          name: 'physicalExaminationWeight',
          title: 'น้ำหนัก',
          suffix: 'กก.',
          dense: true,
          defaultValue: this.formDefault && this.formDefault.physicalExaminationWeight
            ? this.formDefault.physicalExaminationWeight
            : undefined,
          readonly: this.isReadOnly,
          isRequired: true,
          rules: [RuleHelper.required, RuleHelper.number],
        },
      },
      {
        type: INPUT_TYPES.TEXT,
        col: '4',
        props: {
          name: 'physicalExaminationHeight',
          title: 'ส่วนสูง',
          suffix: 'ซม.',
          dense: true,
          defaultValue: this.formDefault && this.formDefault.physicalExaminationHeight
            ? this.formDefault.physicalExaminationHeight
            : undefined,
          readonly: this.isReadOnly,
          isRequired: true,
          rules: [RuleHelper.required, RuleHelper.number],
        },
      },
      {
        type: INPUT_TYPES.TEXT,
        col: '4',
        props: {
          name: 'physicalExaminationWaistline',
          title: 'รอบเอว',
          suffix: 'ซม.',
          dense: true,
          defaultValue: this.formDefault && this.formDefault.physicalExaminationWaistline
            ? this.formDefault.physicalExaminationWaistline
            : undefined,
          readonly: this.isReadOnly,
          isRequired: true,
          rules: [RuleHelper.required, RuleHelper.number],
        },
      },
      {
        type: INPUT_TYPES.TEXT,
        col: '4',
        props: {
          name: 'physicalExaminationTemperature',
          title: 'อุณหภูมิ',
          suffix: 'องศาเซลเซียส',
          dense: true,
          defaultValue: this.formDefault && this.formDefault.physicalExaminationTemperature
            ? this.formDefault.physicalExaminationTemperature
            : undefined,
          readonly: this.isReadOnly,
          rules: [RuleHelper.tempurature],
        },
      },
      {
        type: INPUT_TYPES.TEXT,
        col: '4',
        props: {
          name: 'physicalExaminationHeartRate',
          title: 'อัตรการเต้นของหัวใจ',
          suffix: 'ครั้ง/นาที',
          dense: true,
          defaultValue: this.formDefault && this.formDefault.physicalExaminationHeartRate
            ? this.formDefault.physicalExaminationHeartRate
            : undefined,
          readonly: this.isReadOnly,
          rules: [RuleHelper.number],
        },
      },
      {
        type: INPUT_TYPES.TEXT,
        col: '4',
        props: {
          name: 'physicalExaminationBloodPressure',
          title: 'ความดันโลหิต',
          placeholder: '120/80',
          suffix: 'มม. ปรอท',
          dense: true,
          defaultValue: this.formDefault && this.formDefault.physicalExaminationBloodPressure
            ? this.formDefault.physicalExaminationBloodPressure
            : undefined,
          readonly: this.isReadOnly,
          rules: [RuleHelper.bloodPressure],
        },
      },
    ]
  }

  // ง. ประวัติการเจ็บป่วยและการรักษาโรค
  get history(): IFormOption[] {
    const defaultValueList = this.formDefault &&
      this.formDefault.historyDisease &&
      this.formDefault.historyDisease[0]
        ? this.formDefault.historyDisease[0]
        : undefined
    return [
      {
        type: INPUT_TYPES.TITLE,
        col: '12',
        props: {
          title: 'ประวัติการเจ็บป่วยและการรักษา',
        },
      },
      // {
      //   type: INPUT_TYPES.SUBTITLE,
      //   col: '12',
      //   props: {
      //     title: 'โรคประจำตัวที่ยังรักษาอยู่ <span class="red--text">*</span>',
      //   },
      // },
      {
        type: INPUT_TYPES.GROUP,
        col: '12',
        props: {
          name: 'historyDisease',
          isAction: !this.isReadOnly,
          defaultValue: this.formDefault && this.formDefault.historyDisease
            ? this.formDefault.historyDisease
            : undefined,
          options: [{
            fields: [
              {
                type: INPUT_TYPES.TEXT,
                col: '6',
                props: {
                  title: 'โรค',
                  name: 'historyDisease[0].disease',
                  prefix: '1.',
                  defaultValue: defaultValueList && defaultValueList.disease
                      ? defaultValueList.disease
                      : undefined,
                  readonly: this.isReadOnly,
                  dense: true,
                  // width: this.$vuetify.breakpoint.mdAndUp ? 49 : 100,
                  isRequired: true,
                  rules: [RuleHelper.required],
                },
              },
              {
                type: INPUT_TYPES.TEXT,
                col: '6',
                props: {
                  name: 'historyDisease[0].hospital',
                  title: 'โรงพยาบาลที่ทำการรักษา',
                  dense: true,
                  defaultValue: defaultValueList && defaultValueList.hospital
                      ? defaultValueList.hospital
                      : undefined,
                  readonly: this.isReadOnly,
                  isRequired: true,
                  rules: [RuleHelper.required],
                },
              },
              {
                type: INPUT_TYPES.AUTOCOMPLETE,
                col: '3',
                props: {
                  name: 'historyDisease[0].hospitalProvince',
                  title: 'จังหวัด',
                  dense: true,
                  defaultValue: defaultValueList && defaultValueList.hospitalProvince
                    ? defaultValueList.hospitalProvince
                    : undefined,
                  readonly: this.isReadOnly,
                  isRequired: true,
                  rules: [RuleHelper.required],
                  options: this.province,
                  on: {
                    change: (provinceValue, name) => {
                      const split = _.split(name, '.')
                      const index = split[0].substring(split[0].length - 2, split[0].length - 1)
                      if (index === '0') {
                        this.provinceValue = provinceValue
                      }
                      this.doAssignOptions(
                        this.province,
                        this.district,
                        provinceValue,
                        name,
                        'hospitalDistrict',
                        'provinceId',
                        ['hospitalSubDistrict'],
                      )
                    },
                  },
                },
              },
              {
                type: INPUT_TYPES.AUTOCOMPLETE,
                col: '3',
                props: {
                  name: 'historyDisease[0].hospitalDistrict',
                  title: 'เขต / อำเภอ',
                  dense: true,
                  defaultValue: defaultValueList && defaultValueList.hospitalDistrict
                    ? defaultValueList.hospitalDistrict
                    : undefined,
                  readonly: this.isReadOnly,
                  isRequired: true,
                  rules: [RuleHelper.required],
                  options: this.isReadOnly
                    ? this.district
                    : (
                        this.provinceValue === ''
                          ? this.district
                          : this.doFilterOptionLists(this.province, this.district, this.provinceValue, 'provinceId')
                      ),
                  on: {
                    change: (districtValue, name) => {
                      const split = _.split(name, '.')
                      const index = split[0].substring(split[0].length - 2, split[0].length - 1)
                      if (index === '0') {
                        this.districtValue = districtValue
                      }
                      this.doAssignOptions(
                        this.district,
                        this.subDistrict,
                        districtValue,
                        name,
                        'hospitalSubDistrict',
                        'districtId',
                      )
                    },
                  },
                },
              },
              {
                type: INPUT_TYPES.AUTOCOMPLETE,
                col: '3',
                props: {
                  name: 'historyDisease[0].hospitalSubDistrict',
                  title: 'แขวง / ตำบล',
                  dense: true,
                  defaultValue: defaultValueList && defaultValueList.hospitalDistrict
                    ? defaultValueList.hospitalDistrict
                    : undefined,
                  readonly: this.isReadOnly,
                  isRequired: true,
                  rules: [RuleHelper.required],
                  options: this.isReadOnly
                    ? this.subDistrict
                    : (
                        this.districtValue === ''
                          ? this.subDistrict
                          : this.doFilterOptionLists(this.district, this.subDistrict, this.districtValue, 'districtId')
                      ),
                },
              },
              {
                type: INPUT_TYPES.TEXT,
                col: '3',
                props: {
                  name: 'historyDisease[0].hospitalMobileNo',
                  title: 'เบอร์โทรศัพท์โรงพยาบาล',
                  dense: true,
                  maxlength: '10',
                  defaultValue: defaultValueList && defaultValueList.hospitalMobileNo
                    ? defaultValueList.hospitalMobileNo
                    : undefined,
                  readonly: this.isReadOnly,
                  rules: [RuleHelper.phone],
                },
              },
              {
                type: INPUT_TYPES.TEXT,
                col: '4',
                props: {
                  name: 'historyDisease[0].appointmentRound',
                  title: 'ตารางนัดตรวจล่วงหน้าครั้งที่',
                  dense: true,
                  defaultValue: defaultValueList && defaultValueList.appointmentRound
                    ? defaultValueList.appointmentRound
                    : undefined,
                  readonly: this.isReadOnly,
                  rules: [RuleHelper.number],
                },
              },
              {
                type: INPUT_TYPES.DATE,
                col: '4',
                props: {
                  name: 'historyDisease[0].appointmentDate',
                  title: 'วันที่',
                  dense: true,
                  allowDate: (date) => moment(date).diff(moment(), 'days') > -1,
                  defaultValue: defaultValueList && defaultValueList.appointmentDate
                    ? defaultValueList.appointmentDate
                    : undefined,
                  readonly: this.isReadOnly,
                  rules: [RuleHelper.date],
                },
              },
              {
                type: INPUT_TYPES.TIME,
                col: '4',
                props: {
                  name: 'historyDisease[0].appointmentTime',
                  title: 'เวลา',
                  dense: true,
                  placeholder: '00:00',
                  defaultValue: defaultValueList && defaultValueList.appointmentTime
                    ? defaultValueList.appointmentTime
                    : undefined,
                  readonly: this.isReadOnly,
                },
              },
            ],
          }],
        },
      },
    ]
  }

  // การรับประทานยาต่อเนื่อง
  get medicationLongTerm(): IFormOption[] {
    const defaultValueList = this.formDefault &&
      this.formDefault.medicationLongTerm &&
      this.formDefault.medicationLongTerm[0]
        ? this.formDefault.medicationLongTerm[0]
        : undefined
    return [
      {
        type: INPUT_TYPES.TITLE,
        col: '12',
        props: {
          title: 'การรับประทานยาต่อเนื่อง',
        },
      },
      {
        type: INPUT_TYPES.GROUP,
        col: '12',
        props: {
          name: 'medicationLongTerm',
          isAction: !this.isReadOnly,
          defaultValue: this.formDefault && this.formDefault.medicationLongTerm
            ? this.formDefault.medicationLongTerm
            : undefined,
          options: [{
            fields: [
              {
                type: INPUT_TYPES.TEXT,
                col: '9',
                props: {
                  name: 'medicationLongTerm[0].medicineName',
                  prefix: '1.',
                  dense: true,
                  defaultValue: defaultValueList && defaultValueList.medicineName
                    ? defaultValueList.medicineName
                    : undefined,
                  readonly: this.isReadOnly,
                  isHideDetail: !this.isReadOnly,
                },
              },
              {
                type: INPUT_TYPES.RADIO,
                col: '3',
                props: {
                  name: 'medicationLongTerm[0].isLongTerm',
                  defaultValue: defaultValueList && defaultValueList.isLongTerm
                    ? defaultValueList.isLongTerm
                    : undefined,
                  readonly: this.isReadOnly,
                  isHideDetail: !this.isReadOnly,
                  direction: { row: true, column: false },
                  options: [
                    { text: 'ครบ', value: '1' },
                    { text: 'ไม่ครบ', value: '0' },
                  ],
                },
              },
            ],
          }],
        },
      },
    ]
  }

  // การดูแลพิเศษ
  get specialCare(): IFormOption[] {
    const defaultValueList = this.formDefault && this.formDefault.specialCare && this.formDefault.specialCare[0]
      ? this.formDefault.specialCare[0]
      : undefined
    return [
      {
        type: INPUT_TYPES.TITLE,
        col: '12',
        props: {
          title: 'การดูแลพิเศษ',
        },
      },
      {
        type: INPUT_TYPES.GROUP,
        col: '12',
        props: {
          name: 'specialCare',
          isAction: !this.isReadOnly,
          defaultValue: this.formDefault && this.formDefault.specialCare
            ? this.formDefault.specialCare
            : undefined,
          options: [{
            fields: [
              {
                type: INPUT_TYPES.TEXT,
                col: '12',
                props: {
                  name: 'specialCare[0].description',
                  prefix: '1.',
                  dense: true,
                  defaultValue: defaultValueList && defaultValueList.description
                    ? defaultValueList.description
                    : undefined,
                  readonly: this.isReadOnly,
                  isHideDetail: !this.isReadOnly,
                },
              },
              // {
              //   type: INPUT_TYPES.RADIO,
              //   col: '2',
              //   props: {
              //     name: 'specialCare[0].isSpecialCare',
              //     defaultValue: defaultValueList && defaultValueList.isSpecialCare
              //       ? defaultValueList.isSpecialCare
              //       : undefined,
              //     readonly: this.isReadOnly,
              //     isHideDetail: !this.isReadOnly,
              //     direction: { row: true, column: false },
              //     options: [
              //       { text: 'ถูก', value: '1' },
              //       { text: 'ไม่ถูก', value: '0' },
              //     ],
              //   },
              // },
            ],
          }],
        },
      },
    ]
  }

  // แบบประเมินความสามารถในการปฏิบัติกิจวัตรประจำวัน (ADL Barthel Index)
  get adlBarthelIndex(): IFormOption[] {
    return [
      {
        type: INPUT_TYPES.TITLE,
        col: '12',
        props: {
          title: 'แบบประเมินความสามารถในการปฏิบัติกิจวัตรประจำวัน (ADL Barthel Index)',
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '1. การรับประทานอาหาร (Feeding)',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'adlBarthelIndexFeedingNo1',
          defaultValue: this.formDefault && this.formDefault.adlBarthelIndexFeedingNo1
             ? this.formDefault.adlBarthelIndexFeedingNo1
             : undefined,
          readonly: this.isReadOnly,
          direction: { row: false, column: true },
          options: [
            { text: 'ต้องมีคนป้อนให้ หรือรับอาหารทางสายยาง', value: '0' },
            { text: 'ตักอาหารเองได้ แต่ต้องมีคนช่วย เช่น ช่วยใช้ช้อนตักเตรียมไว้ให้', value: '5' },
            { text: 'ตักอาหารและช่วยตัวเองได้เป็นปกติ เมื่อเตรียมอาหารวางไว้ให้', value: '10' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '2. การเคลื่อนย้าย (Transfers)',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'adlBarthelIndexTransfersNo2',
          defaultValue: this.formDefault && this.formDefault.adlBarthelIndexTransfersNo2
            ? this.formDefault.adlBarthelIndexTransfersNo2
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: false, column: true },
          options: [
            { text: 'ไม่สามารถนั่งได้ (นั่งแล้วจะล้มเสมอ) หรือต้องใช้คน 2 คนช่วยกันยกขึ้น', value: '0' },
            { text: 'ต้องการความช่วยเหลืออย่างมากจึงจะนั่งได้ เช่น ต้องใช้คนที่แข็งแรงหรือมีทักษะ 1 คน หรือใช้คนทั่วไป 2 คนพยุง หรือดันขึ้นมาจึงจะนั่งอยู่ได้', value: '5' },
            {
              text: 'ต้องการความช่วยเหลือบ้าง เช่น บอกให้ทำตามหรือช่วยพยุงเล็กน้อย หรือต้องมีคนดูแลเพื่อความปลอดภัย',
              value: '10',
            },
            { text: 'ทำได้เอง', value: '15' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '3. การเดินการเคลื่อนไหว (Mobility)',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'adlBarthelIndexMobilityNo3',
          defaultValue: this.formDefault && this.formDefault.adlBarthelIndexMobilityNo3
            ? this.formDefault.adlBarthelIndexMobilityNo3
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: false, column: true },
          options: [
            { text: 'เคลื่อนที่ไปไหนไม่ได้', value: '0' },
            { text: 'ต้องใช้รถเข็นช่วยตัวเองให้เคลื่อนที่ได้เอง(ไม่ต้องมีคนเข็นให้) และจะต้องเข้าออกมุมห้องหรือประตูได้ด้', value: '5' },
            {
              text: 'เดินหรือเคลื่อนที่โดยมีคนช่วย เช่น พยุง หรือบอกให้ทำตาม หรือต้องให้ความสนใจดูแลเพื่อความปลอดภัย',
              value: '10',
            },
            { text: 'เดินหรือเคลื่อนที่ได้เอง', value: '15' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '4. การแต่งตัวสวมใส่เสื้อผ้า (Dressing)',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'adlBarthelIndexDressingNo4',
          defaultValue: this.formDefault && this.formDefault.adlBarthelIndexDressingNo4
            ? this.formDefault.adlBarthelIndexDressingNo4
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: false, column: true },
          options: [
            { text: 'ต้องมีคนสวมใส่ให้ ช่วยตัวเองแทบไม่ได้หรือได้น้อย', value: '0' },
            { text: 'ช่วยตัวเองได้ประมาณร้อยละ 50 ที่เหลือต้องมีคนช่วย', value: '5' },
            {
              text: 'ช่วยตัวเองได้ดี (รวมทั้งการติดกระดุม รูดซิป หรือใส่เสื้อผ้าที่ดัดแปลงให้เหมาะสมก็ได้)',
              value: '10',
            },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '5. การอาบน้ำเช็คตัว (Bathing)',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'adlBarthelIndexBathingNo5',
          defaultValue: this.formDefault && this.formDefault.adlBarthelIndexBathingNo5
            ? this.formDefault.adlBarthelIndexBathingNo5
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: false, column: true },
          options: [
            { text: 'ต้องมีคนช่วยหรือทำให้', value: '0' },
            { text: 'อาบน้ำได้เอง', value: '5' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '6. สุขวิทยาส่วนบุคคล (Grooming)',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'adlBarthelIndexGroomingNo6',
          defaultValue: this.formDefault && this.formDefault.adlBarthelIndexGroomingNo6
            ? this.formDefault.adlBarthelIndexGroomingNo6
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: false, column: true },
          options: [
            { text: 'ต้องการความช่วยเหลือ', value: '0' },
            { text: 'ทำได้เอง (รวมทั้งที่ทำได้เองถ้าเตรียมอุปกรณ์ไว้ให้)', value: '5' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '7. การใช้ห้องสุขา หรือกระโถน (Toilet use)',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'adlBarthelIndexToiletUseNo7',
          defaultValue: this.formDefault && this.formDefault.adlBarthelIndexToiletUseNo7
            ? this.formDefault.adlBarthelIndexToiletUseNo7
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: false, column: true },
          options: [
            { text: 'ช่วยตัวเองไม่ได้', value: '0' },
            {
              text: 'ทำเองได้บ้าง (อย่างน้อยทำความสะอาดตัวเองได้หลังจากเสร็จธุระ) แต่ต้องการความช่วยเหลือในบางสิ่ง',
              value: '5',
            },
            { text: 'ช่วยเหลือตัวเองได้ดี (ขึ้นนั่งและลงจากโถส้วมเองได้ ทำความสะอาดได้เรียบร้อยหลังจากเสร็จธุระ ถอดใส่เสื้อผ้าได้เรียบร้อย)', value: '10' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '8. การควบคุมการถ่ายอุจจาระ (Bowels)',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'adlBarthelIndexBowelsNo8',
          defaultValue: this.formDefault && this.formDefault.adlBarthelIndexBowelsNo8
            ? this.formDefault.adlBarthelIndexBowelsNo8
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: false, column: true },
          options: [
            { text: 'กลั้นไม่ได้ หรือต้องการการสวนอุจจาระอยู่เสมอ', value: '0' },
            { text: 'กลั้นไม่ได้บางครั้ง (ไม่เกิน 1 ครั้งต่อสัปดาห์)', value: '5' },
            { text: 'กลั้นได้เป็นปกติ', value: '10' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '9. การควบคุมการถ่ายปัสสาวะ (Bladder)',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'adlBarthelIndexBladderNo9',
          defaultValue: this.formDefault && this.formDefault.adlBarthelIndexBladderNo9
            ? this.formDefault.adlBarthelIndexBladderNo9
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: false, column: true },
          options: [
            { text: 'กลั้นไม่ได้ หรือใส่สายสวนปัสสาวะ แต่ไม่สามารถดูแลเองได้', value: '0' },
            { text: 'กลั้นไม่ได้บางครั้ง (ไม่เกินวันละ 1 ครั้ง)', value: '5' },
            { text: 'กลั้นได้เป็นปกติ', value: '10' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: '10. การขึ้นลงบันได (Stairs)',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '12',
        props: {
          name: 'adlBarthelIndexStairsNo10',
          defaultValue: this.formDefault && this.formDefault.adlBarthelIndexStairsNo10
            ? this.formDefault.adlBarthelIndexStairsNo10
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: false, column: true },
          options: [
            { text: 'ไม่สามารถทำได้', value: '0' },
            { text: 'ต้องการคนช่วย', value: '5' },
            {
              text: 'ขึ้นลงได้เอง (ถ้าต้องใช้เครื่องช่วยเดิน เช่น Walker จะต้องเอาขึ้นลงได้ด้วย)',
              value: '10',
            },
          ],
        },
      },
      {
        type: INPUT_TYPES.TEXT,
        col: '12',
        props: {
          name: 'adlBarthelIndexTotal',
          title: 'รวมคะแนน ADL',
          suffix: 'คะแนน',
          dense: true,
          readonly: true,
          defaultValue: this.formDefault && this.formDefault.adlBarthelIndexTotal
            ? this.formDefault.adlBarthelIndexTotal
            : undefined,
          width: this.$vuetify.breakpoint.mdAndUp ? 30 : 100,
          isActive: false,
          style: 'display:none;',
        },
      },
    ]
  }

  // จ. อัตราการเกิดภาวะแทรกซ้อน
  get complicationRate(): IFormOption[] {
    return [
      {
        type: INPUT_TYPES.TITLE,
        col: '12',
        props: {
          title: 'อัตราการเกิดภาวะแทรกซ้อน',
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '6',
        props: {
          title: '1. แผลกดทับจากที่บ้าน',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '6',
        props: {
          name: 'complicationRateNo1',
          defaultValue: this.formDefault && this.formDefault.complicationRateNo1
            ? this.formDefault.complicationRateNo1
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'มี', value: '1' },
            { text: 'ไม่มี', value: '0' },
            { text: 'ไม่แน่ใจ', value: '-1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '6',
        props: {
          title: '2. ปอดบวม',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '6',
        props: {
          name: 'complicationRateNo2',
          defaultValue: this.formDefault && this.formDefault.complicationRateNo2
            ? this.formDefault.complicationRateNo2
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'มี', value: '1' },
            { text: 'ไม่มี', value: '0' },
            { text: 'ไม่แน่ใจ', value: '-1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '6',
        props: {
          title: '3. ติดเชื้อทางเดินปัสสาวะ',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '6',
        props: {
          name: 'complicationRateNo3',
          defaultValue: this.formDefault && this.formDefault.complicationRateNo3
            ? this.formDefault.complicationRateNo3
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'มี', value: '1' },
            { text: 'ไม่มี', value: '0' },
            { text: 'ไม่แน่ใจ', value: '-1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '6',
        props: {
          title: '4. ข้อติดแข็ง',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '6',
        props: {
          name: 'complicationRateNo4',
          defaultValue: this.formDefault && this.formDefault.complicationRateNo4
            ? this.formDefault.complicationRateNo4
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'มี', value: '1' },
            { text: 'ไม่มี', value: '0' },
            { text: 'ไม่แน่ใจ', value: '-1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '6',
        props: {
          title: '5. อารมณ์ซึมเศร้า',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '6',
        props: {
          name: 'complicationRateNo5',
          defaultValue: this.formDefault && this.formDefault.complicationRateNo5
            ? this.formDefault.complicationRateNo5
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'มี', value: '1' },
            { text: 'ไม่มี', value: '0' },
            { text: 'ไม่แน่ใจ', value: '-1' },
          ],
        },
      },
    ]
  }

  // ฉ. ความต้องการการดูแลพิเศษจากนักบริบาลผู้สูงอายุ
  get needCaregiver(): IFormOption[] {
    return [
      {
        type: INPUT_TYPES.TITLE,
        col: '12',
        props: {
          title: 'ความต้องการการดูแลพิเศษจากนักบริบาลผู้สูงอายุ',
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '6',
        props: {
          title: '1. การทำความสะอาดแผล',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '6',
        props: {
          name: 'needCaregiverWoundNo1',
          defaultValue: this.formDefault && this.formDefault.needCaregiverWoundNo1
            ? this.formDefault.needCaregiverWoundNo1
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'มี', value: '1' },
            { text: 'ไม่มี', value: '0' },
            { text: 'ไม่แน่ใจ', value: '-1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '6',
        props: {
          title: '2. การป้องกันแผลกดทับ',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '6',
        props: {
          name: 'needCaregiverPressureUlcersNo2',
          defaultValue: this.formDefault && this.formDefault.needCaregiverPressureUlcersNo2
            ? this.formDefault.needCaregiverPressureUlcersNo2
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'มี', value: '1' },
            { text: 'ไม่มี', value: '0' },
            { text: 'ไม่แน่ใจ', value: '-1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '6',
        props: {
          title: '3. การใช้อ็อกซิเจน',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '6',
        props: {
          name: 'needCaregiverOxygenNo3',
          defaultValue: this.formDefault && this.formDefault.needCaregiverOxygenNo3
            ? this.formDefault.needCaregiverOxygenNo3
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'มี', value: '1' },
            { text: 'ไม่มี', value: '0' },
            { text: 'ไม่แน่ใจ', value: '-1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '6',
        props: {
          title: '4. การให้อาหารทางสายยาง',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '6',
        props: {
          name: 'needCaregiverTubeFeedingNo4',
          defaultValue: this.formDefault && this.formDefault.needCaregiverTubeFeedingNo4
            ? this.formDefault.needCaregiverTubeFeedingNo4
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'มี', value: '1' },
            { text: 'ไม่มี', value: '0' },
            { text: 'ไม่แน่ใจ', value: '-1' },
          ],
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '6',
        props: {
          title: '5. การดูแลสายสวนปัสสาวะ',
        },
      },
      {
        type: INPUT_TYPES.RADIO,
        col: '6',
        props: {
          name: 'needCaregiverUrinaryCatheterCareNo5',
          defaultValue: this.formDefault && this.formDefault.needCaregiverUrinaryCatheterCareNo5
            ? this.formDefault.needCaregiverUrinaryCatheterCareNo5
            : undefined,
          readonly: this.isReadOnly,
          direction: { row: true, column: false },
          options: [
            { text: 'มี', value: '1' },
            { text: 'ไม่มี', value: '0' },
            { text: 'ไม่แน่ใจ', value: '-1' },
          ],
        },
      },
    ]
  }

  protected updateForm(data: { [key: string]: any }) {
    // Selected other
    this.patientHealthy.forEach((item: IFormOption) => {
      if (_.includes([
        'patientHealthyMedicalTreatmentOther',
        'patientHealthyCaretakerRelationOther',
      ], item.props.name)) {
        const key = item.props.name.substring(0, item.props.name.length - 5)
        item.isHide = data[key] !== 'อื่นๆ'
      }
    })

    // Calculate ADL point
    let sum = 0
    this.adlBarthelIndex.forEach((item: IFormOption) => {
      if (!_.includes(item.props.name, 'Total')) {
        const point: number = data[item.props.name] ? _.toInteger(data[item.props.name]) : 0
        sum = sum + point
      } else {
        item.props.defaultValue = _.toString(sum)
      }
    })
  }

  private doAssignOptions(lists, childLists, value, name, fieldStoreName, itemIdName, resetFieldStore = []) {
    let options = []
    let split = _.split(name, '.')
    this.history.forEach((item: IFormOption) => {
      if (item.type === INPUT_TYPES.GROUP) {
        _.forEach(item.props.options, (option, index: string) => {
          _.forEach(option.fields, (subitem: IFormOption) => {
            const fieldName = `${split[0].substring(0, split[0].length - 3)}[${index}].${fieldStoreName}`
            const fieldIndex = split[0].substring(split[0].length - 2, split[0].length - 1)
            if (index.toString() === fieldIndex) {
              if (subitem.props.name === fieldName) {
                options = this.doFilterOptionLists(lists, childLists, value, itemIdName)
                subitem.props.options = options
                this.$store.dispatch(
                  'form/updateAttr',
                  {
                    formName: this.formName,
                    attrName: fieldName,
                    value: null,
                  },
                )
              } else {
                split = _.split(subitem.props.name, '.')
                if (_.includes(resetFieldStore, split[1])) {
                  subitem.props.options = []
                  this.$store.dispatch(
                    'form/updateAttr',
                    {
                      formName: this.formName,
                      attrName: subitem.props.name,
                      value: null,
                    },
                  )
                }
              }
            }
          })
        })
      }
    })
  }

  private doFilterOptionLists(lists, childLists, value, itemIdName) {
    const found = _.find(lists, (item) => item.value === value)
    return found ? _.filter(childLists, (item) => item[itemIdName] === found.id) : []
  }

  private async submitForm(rawData) {
    this.data = rawData
    const data = this.doConvertStringToInt(this.data)
    try {
      this.loading = true
      await this.putPatientAssessment({
        id: this.$route.params.status,
        ...data,
      })
      this.updateSnackbar({txt: 'บันทึกข้อมูลแบบสอบถามสำเร็จ', type: 'success'})
      this.loading = false
      this.$router.push(`/main/patient`)
    } catch (e) {
      this.loading = false
    }
  }
}
